/**
 * @generated SignedSource<<e99e5f77398de72ed1eaf920aeb05693>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum CommentType {
  FOOTER = "FOOTER",
  INLINE = "INLINE",
  RESOLVED = "RESOLVED",
  UNRESOLVED = "UNRESOLVED",
}
export enum Depth {
  ALL = "ALL",
  ROOT = "ROOT",
}
export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}
export type useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
  };
export type useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    type: string;
  };
export type useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList_nodes_Comment_location =

    | useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment
    | useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment;
export type useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList_nodes_Comment =
  {
    __typename?: "Comment";
    id: string;
    parentId: string | null;
    location: useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList_nodes_Comment_location;
  };
export type useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList =
  {
    __typename?: "PaginatedCommentList";
    nodes: Array<useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList_nodes_Comment | null> | null;
  };
export type useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_Query = {
  __typename?: "Query";
  comments: useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_comments_PaginatedCommentList | null;
};
export type useCommentRefetchInlineCommentTopLevelMarkerRefsQueryVariables =
  Exact<{
    pageId: Scalars["ID"]["input"];
    contentStatus?: InputMaybe<
      Array<InputMaybe<GraphQLContentStatus>> | InputMaybe<GraphQLContentStatus>
    >;
    depth?: InputMaybe<Depth>;
    type?: InputMaybe<Array<InputMaybe<CommentType>> | InputMaybe<CommentType>>;
  }>;
export type useCommentRefetchInlineCommentTopLevelMarkerRefsQuery =
  useCommentRefetchInlineCommentTopLevelMarkerRefsQuery_Query;
